import React, { Fragment, useState, useEffect } from "react";
import {
  useListContext,
  useNotify,
  useUnselectAll,
  useRefresh,
} from "react-admin";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Typography,
  Grid,
} from "@mui/material";

const BulkSendSmsButton = () => {
  const { selectedIds = [] } = useListContext();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [smsMessage, setSmsMessage] = useState("");
  const [mode, setMode] = useState("selected");
  const [gender, setGender] = useState("");
  const [states, setStates] = useState("");
  const [subcatogories, setSubcatogories] = useState("");
  const [subcatogory, setSubcatogory] = useState("");
  const [state, setState] = useState("");
  // const [typeFilter, setTypeFilter] = useState("");
  const [type, setType] = useState("");
  const [total, setTotal] = useState("");
  const genders = ["male", "female"];
  const types = ["supplier", "buyer", "farmer", "cooperative", "marketer","service_provider"];
  const handleClick = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSmsMessage("");
    setGender("");
    setState("");
    setSubcatogory("");
    setType("");
    setMode("selected");
  };
  const isDisabled =
    !smsMessage.trim() || (mode === "selected" && selectedIds.length === 0);
  const disableReason =
    mode === "selected" && selectedIds.length === 0
      ? "You must select at least one user"
      : !smsMessage.trim()
      ? "Message cannot be empty"
      : "";
  const token = JSON.parse(localStorage.getItem("token"));

  const handleSend = async () => {
    setLoading(true);
    try {
      const body =
        mode === "selected"
          ? {
              message: smsMessage,
              smsMessage,
              channels: ["sms"],
              userIds: selectedIds,
              states:null,
              subCategories:null,
            }
          : {
              message: smsMessage,
              smsMessage,
              channels: ["sms"],
              userTypes :type? [type]:null,
              states:state?[state]: null,
              subCategories:subcatogory? [subcatogory]:null,
            };

      const response = await fetch(
        `${process.env.REACT_APP_URL}/admin/notifications`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Unknown error");
      }

      notify("SMS sent successfully", { type: "success" });
    } catch (error) {
      console.error(error);
      notify(`Error sending SMS: ${error.message}`, { type: "error" });
    } finally {
      setLoading(false);
      handleClose();
      unselectAll("users");
      refresh();
    }
  };

  useEffect(()=>{
    setCountLoading(true)
    const getUsersCount = async () => {
      try {
        const params = new URLSearchParams();
        let filterIndex = 0;

        if (type) {
          params.append(`filter[${filterIndex++}]`, `type||$eq||${type}`);
        }
        if (gender) {
          params.append(`filter[${filterIndex++}]`, `gender||$cont||${gender}`);
        }
        if (subcatogory) {
          params.append(`filter[${filterIndex++}]`, `subCategory_id||$eq||${Number(subcatogory)}`);
        }
        if (state) {
          params.append(`filter[${filterIndex++}]`, `location||$eq||${state}`);
        }
        
        const url =
          `${process.env.REACT_APP_URL}/admin/users` +
          (params.toString() ? `?${params.toString()}` : "");
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        const result = await response.json();
        setTotal(result.total)
  
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Unknown error");
        }
  
      } catch (error) {
        console.error(error);
        notify(`Error sending SMS: ${error.message}`, { type: "error" });
      } finally {
        setCountLoading(false)
        refresh();
      }
    };
    getUsersCount();
  },[subcatogory,state,type,gender])
  
  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const stateResponse = await fetch(
          `${process.env.REACT_APP_URL}/admin/state`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const statesData = await stateResponse.json();
        setStates(statesData);
        const subcategoriesResponse = await fetch(
          `${process.env.REACT_APP_URL}/admin/sub_category`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        const subcategoriesData = await subcategoriesResponse.json();
        setSubcatogories(subcategoriesData);
      } catch (err) {
        console.error("Error fetching report:", err);
        setError(err.message);
      } finally {
      }
      
    };

    fetchReportData();
  }, []);
  return (
    <Fragment>
      <Tooltip
        title={
          mode === "selected" && selectedIds.length === 0
            ? "First select users"
            : ""
        }
      >
        <span>
          <Button
            variant="contained"
            size="small"
            onClick={handleClick}
            sx={{ mr: 1 }}
          >
            Send SMS
          </Button>
        </span>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 2 },
        }}
      >
     
            <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
              Send SMS to ( {countLoading?"waiting...": mode === "selected" ? selectedIds.length :total} ) user
              {selectedIds.length > 1 && "s"}
            </DialogTitle>
            <Divider />


        <DialogContent sx={{ mt: 2 }}>
          {/* Mode Toggle */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <ToggleButtonGroup
              value={mode}
              exclusive
              onChange={(e, value) => value && setMode(value)}
              sx={{
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
                p: 0.5,
              }}
            >
              <ToggleButton value="selected" sx={{ px: 3 }}>
                Selected Users
              </ToggleButton>
              <ToggleButton value="filter" sx={{ px: 3 }}>
                By Filter
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {/* Filter dropdowns */}
          {mode === "filter" && (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                gap: 2,
                mb: 3,
              }}
            >
              <Grid item xs={6} sm={3} md={6}>
                <Typography variant="subtitle2">Gender</Typography>
                <Select
                  fullWidth
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  displayEmpty
                  size="small"
                >
                  <MenuItem value="">Any</MenuItem>
                  {genders.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={6} sm={3} md={2}>
                <Typography variant="subtitle2">Type</Typography>
                <Select
                  fullWidth
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  displayEmpty
                  size="small"
                >
                  <MenuItem value="">Any</MenuItem>
                  {types.map((g) => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={6} sm={3} md={6}>
                <Typography variant="subtitle2">State</Typography>
                <Select
                  fullWidth
                  value={state}
                  onChange={(e)=> {
                    setState(e.target.value)
                    // getUsersCount()
                    }}
                  displayEmpty
                  size="small"
                >
                  <MenuItem value="">All</MenuItem>
                  {states.map((state) => (
                    <MenuItem key={state.id} value={state.id}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={6} sm={3} md={6}>
                <Typography variant="subtitle2">Sub_category</Typography>
                <Select
                  fullWidth
                  value={subcatogory}
                  onChange={(e) => setSubcatogory(e.target.value)}
                  displayEmpty
                  size="small"
                >
                  <MenuItem value="">All</MenuItem>
                  {subcatogories["data"].map((sub_category) => (
                    <MenuItem key={sub_category.id} value={sub_category.id}>
                      {sub_category.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Box>
          )}

          {/* SMS message field */}
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            SMS Message
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={5}
            placeholder="Type your message..."
            value={smsMessage}
            onChange={(e) => setSmsMessage(e.target.value)}
            sx={{
              backgroundColor: "#fafafa",
              borderRadius: 2,
            }}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
          <Button
            onClick={handleClose}
            sx={{ color: "text.secondary", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Tooltip title={isDisabled ? disableReason : ""} arrow>
            {/* span wrapper so tooltip still works on disabled button */}
            <span>
              <Button
                variant="contained"
                onClick={handleSend}
                disabled={isDisabled}
                color="primary"
              >
                 {loading ? "Sending..." : "Send"}
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BulkSendSmsButton;
